<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable width="650">
    <v-card tile flat>
      <v-toolbar dark color="primary">
        <v-app-bar-nav-icon>
          <v-icon>fa-user-edit</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title v-if="registrationSuccess === true">Details updated</v-toolbar-title>
        <v-toolbar-title v-else>Edit details for: {{ updateData.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0" style="height: 100vh">
        <v-stepper vertical v-model="step" class="elevation-0">
          <v-stepper-step
            step="1"
            :complete="step > 1"
            :rules="[() => valid[1]]"
            error-icon="priority_high"
            complete-icon="done"
            edit-icon="done"
            editable
            class="ma-0"
          >
            Contact Details
            <small v-if="RegistrationEmailExists">Email address is already registered</small>
            <small v-else>The primary contact for the business</small>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form ref="step1ref" v-model="valid[1]" lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex>
                        <v-layout wrap>
                          <v-flex xs12 sm2 md2>
                            <v-select
                              :items="titles"
                              :label="'Title *'"
                              v-model="titleSelect"
                              :rules="[value => !!value || 'This field is required']"
                              required
                            >
                            </v-select>
                          </v-flex>
                          <v-flex xs12 sm2 md2 v-if="showTitleInput">
                            <v-text-field
                              label="Title *"
                              v-model="updateData.users[0].name.title"
                              :rules="[value => !!value || 'This field is required']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-bind="vFlexNameProps">
                            <v-text-field
                              label="First name *"
                              v-model="updateData.users[0].name.first"
                              :rules="[value => !!value || 'This field is required']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-bind="vFlexNameProps">
                            <v-text-field
                              label="Last name *"
                              v-model="updateData.users[0].name.last"
                              :rules="[value => !!value || 'This field is required']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              label="Email *"
                              v-model="verifiedEmail"
                              :rules="emailRules"
                              :error-messages="emailErrorMessage"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              label="Phone *"
                              v-model="updateData.users[0].phone"
                              :rules="[value => !!value || 'This field is required']"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn
              color="accent"
              @click.native="(step = 2) && validateSteps(2)"
              :disabled="!valid[1]"
            >
              Continue
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
            @click.native="validateSteps(2)"
            step="2"
            :complete="step > 2"
            :rules="[() => valid[2]]"
            error-icon="priority_high"
            complete-icon="done"
            edit-icon="done"
            editable
          >
            Business Name & Address
            <small>Search for the name/address or enter manually</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-form ref="step2ref" v-model="valid[2]" lazy-validation>
              <v-container fluid grid-list-md class="pa-0 mb-5">
                <v-row no-gutters>
                  <v-col :cols="colsWidth">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-switch label="Limited Company" v-model="updateData.is_limited" hide-details></v-switch>
                      </v-flex>
                      <v-flex xs12 v-if="updateData.is_limited">
                        <v-autocomplete
                          v-model="companiesHouse"
                          :items="businesses"
                          :search-input.sync="companiesHouseSearch"
                          hide-no-data
                          item-text="title"
                          item-value="API"
                          label="Company name"
                          return-object
                          prepend-icon="fad fa-search"
                          :no-filter="true"
                        >
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.title"></v-list-item-title>
                              <v-list-item-subtitle v-text="item.address_snippet"></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 v-if="!updateData.is_limited">
                        <v-autocomplete
                          v-model="loqateQuery"
                          :items="loqate"
                          :search-input.sync="loqateQuerySearch"
                          hide-no-data
                          item-text="Text"
                          item-value="API"
                          label="Company name or address"
                          return-object
                          prepend-icon="fad fa-search"
                          :no-filter="true"
                        >
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.Text"></v-list-item-title>
                              <v-list-item-subtitle v-text="item.Description"></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 v-if="!updateData.is_limited && showAddressSelect">
                        <v-select
                          v-model="selectedAddress"
                          :items="loqateOptions"
                          placeholder="Select an address"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="business.CommercialName !== null">
                        <v-text-field
                          label="Company Name *"
                          v-model="business.CommercialName"
                          :rules="[value => !!value || 'This field is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm2 v-if="business.BusinessRef !== null">
                        <v-text-field
                          v-if="updateData.is_limited"
                          label="Company Number *"
                          v-model="business.BusinessRef"
                          :rules="[value => !!value || 'This field is required']"
                          required
                        ></v-text-field>
                        <v-text-field
                          v-if="!updateData.is_limited"
                          label="Company Reference *"
                          v-model="business.BusinessRef"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 v-if="business.BusinessRef !== null">
                        <v-select
                          :items="statuses"
                          :label="'Company Status *'"
                          v-model="business.BusinessStatus"
                          item-text="label"
                          item-value="status"
                          :rules="[value => !!value || 'This field is required']"
                          :required="updateData.is_limited"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                        <v-text-field
                          label="Address Line 1 *"
                          v-model.trim="business.BusinessLocation.LocationLine1"
                          :rules="[value => !!value || 'This field is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                        <v-text-field label="Address Line 2" v-model.trim="business.BusinessLocation.LocationLine2">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                        <v-text-field
                          label="City *"
                          v-model.trim="business.BusinessLocation.LocationLine3"
                          :rules="[value => !!value || 'This field is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                        <v-text-field label="Address Line 4" v-model.trim="business.BusinessLocation.LocationLine4">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                        <v-text-field label="Address Line 5" v-model.trim="business.BusinessLocation.LocationLine5">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                        <v-text-field
                          label="Postcode *"
                          v-model.trim="business.BusinessLocation.Postcode"
                          :rules="[
                            value => !!value || 'This field is required',
                            value => value.length <= 8 || 'Postcode may not be greater than 8 characters'
                          ]"
                          required
                        ></v-text-field>
                      </v-flex>
                      <!--                <v-btn text color="pink" @click="manualAddress = false" v-if="!experianError"-->
                      <!--                  >Select address from Experian list</v-btn-->
                      <!--                >-->
                    </v-layout>
                  </v-col>
                </v-row>
              </v-container>
              <v-btn
                color="accent"
                @click.native="(step = 3) && validateSteps(3)"
                :disabled="!valid[2]"
              >
                Continue
              </v-btn>
            </v-form>
          </v-stepper-content>

          <v-stepper-step
            v-if="UserHasRole('Platform')"
            @click.native="validateSteps(3)"
            step="3"
            :complete="step > 3"
            :rules="[() => valid[3]]"
            error-icon="priority_high"
            complete-icon="done"
            edit-icon="done"
            editable
          >
            Referral
            <small>Select a referrer if required</small>
          </v-stepper-step>
          <v-stepper-content v-if="UserHasRole('Platform')" step="3">
            <v-form ref="step3ref" v-model="valid[3]" lazy-validation>
              <v-flex>
                <v-card flat class="mb-5">
                  <v-flex xs12 sm12 v-if="PlatformUser()">
                    <v-autocomplete
                      :items="RegistrationReferrerList"
                      item-text="name"
                      item-value="id"
                      v-model="updateData.referrer.id"
                      label="Referring business"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch label="Send referral email" v-model="referral.sendEmail"></v-switch>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-btn
                color="accent"
                @click.native="(step = 4) && validateSteps(4)"
                :disabled="!valid[3]"
              >
                Continue
              </v-btn>

            </v-form>
          </v-stepper-content>

          <v-stepper-step
            @click.native="validateSteps(3)"
            :step="UserHasRole('Platform') ? 4 : 3"
            :complete="(UserHasRole('Platform') && step > 4) || step > 3"
            error-icon="priority_high"
            complete-icon="done"
            edit-icon="done"
            editable
          >
            Confirm
            <small>Confirm the business details are correct</small>
          </v-stepper-step>
          <v-stepper-content :step="UserHasRole('Platform') ? 4 : 3">
            <v-flex>
              <v-card flat class="pa-0">
                <h3>{{ updateData.name }}</h3>
                <v-list dense class="transparent">
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="pink">person</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                      >{{ updateData.users[0].name.title }} {{ updateData.users[0].name.first }}
                        {{ updateData.users[0].name.last }}
                      </v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="pink">email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ updateData.users[0].email }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="pink">phone</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ updateData.users[0].phone }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="pink">business</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ business.CommercialName }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="pink">location_on</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span v-if="business.BusinessLocation.LocationLine1"
                        >{{ startCase(business.BusinessLocation.LocationLine1) }},
                        </span>
                        <span v-if="business.BusinessLocation.LocationLine2"
                        >{{ startCase(business.BusinessLocation.LocationLine2) }},
                        </span>
                        <span v-if="business.BusinessLocation.LocationLine3"
                        >{{ startCase(business.BusinessLocation.LocationLine3) }},
                        </span>
                        <span v-if="business.BusinessLocation.LocationLine4"
                        >{{ startCase(business.BusinessLocation.LocationLine4) }},
                        </span>
                        <span v-if="business.BusinessLocation.LocationLine5"
                        >{{ startCase(business.BusinessLocation.LocationLine1) }},
                        </span>
                        {{ business.BusinessLocation.Postcode }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="my-4"></v-divider>
                </v-list>
                <v-layout>
                  <v-flex xs6>
                    <v-switch label="Quick Submit" v-model="updateData.auto_send_enquiries"></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch label="Newsletter Signup" v-model="updateData.users[0].newsletter_signup"></v-switch>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-btn
              color="accent"
              @click.native="prepareDetailsAndUpdate"
              :disabled = "!valid[1] || !valid[2] || !valid[3]"
            >
              Update
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :step="UserHasRole('Platform') ? 5 : 4"
            :complete="step > 5"
            :rules="[() => registrationSuccess !== false]"
            error-icon="priority_high"
            complete-icon="done"
            edit-icon="done"
            editable
          >
            Update
            <small v-if="registrationSuccess === false">There was a problem updating the customer</small>
          </v-stepper-step>
          <v-stepper-content :step="UserHasRole('Platform') ? 5 : 4">
            <v-flex>
              <v-card flat class="pa-0">
                <v-progress-linear indeterminate color="pink" size="64" v-if="registrationInProgress" />
                <v-card-text v-if="!registrationInProgress">
                  <v-alert type="success" :value="registrationSuccess === true">
                    Customer has been successfully updated
                  </v-alert>
                  <v-alert type="error" :value="registrationSuccess === false">
                    There was a problem updating the customer
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-btn v-if="!registrationInProgress" color="accent" @click.native="closeDialog">Finish</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import _ from 'lodash'
import {emailRules} from '@/utils/validators'
import companiesHouse from '@/api/companiesHouse'
import loqate from '@/api/loqate'

export default {
  name: 'customer-edit-dialog',
  props: ['show', 'customer'],
  data: () => ({
    step: 1,
    valid: [true, true, true, true, true, true],
    loading: false,
    referralSearch: null,
    registrationInProgress: false,
    updateData: {
      name: null,
      is_limited: false,
      auto_send_enquiries: false,
      address: {
        line_1: null,
        line_2: null,
        line_3: null,
        line_4: null,
        line_5: null,
        post_code: null,
      },
      referrer: {
        id: null,
      },
      users: [{
          name: {
            title: null,
            first: null,
            last: null,
            // titleSelect: null,
          },
          email: null,
          phone: null,
          newsletter_signup: false,
        },
      ],
    },
    business: {
      BusinessRef: null,
      BusinessStatus: 'unknown',
      RegisteredCompanySicCodes: null,
      CommercialName: null,
      BusinessLocation: {
        LocationLine1: null,
        LocationLine2: null,
        LocationLine3: null,
        LocationLine4: null,
        LocationLine5: null,
        Postcode: null,
      },
    },
    referral: {
      id: null,
      sendEmail: false,
    },
    isLimited: true,
    businessCheckTried: false,
    manualAddress: false,
    registrationSuccess: null,
    companiesHouse: null,
    companiesHouseSearch: null,
    loqateQuery: null,
    lastLoqateQuery: null,
    loqateQuerySearch: null,
    loqateQueryName: null,
    loqateQueryNameSearch: null,
    showAddressSelect: false,
    businesses: [],
    loqate: [],
    selectedAddress: null,
    emailRules,
    titles: ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Other'],
    showTitleInput: undefined,
    selectedTitle: undefined,
    statuses: [
      { 'status': 'active', 'label': 'Active' },
      { 'status': 'dissolved', 'label': 'Dissolved' },
      { 'status': 'liquidation', 'label': 'Liquidation' },
      { 'status': 'receivership', 'label': 'Receivership' },
      { 'status': 'administration', 'label': 'Administration' },
      { 'status': 'voluntary-arrangement', 'label': 'Voluntary arrangement' },
      { 'status': 'converted-closed', 'label': 'Converted closed' },
      { 'status': 'insolvency-proceedings', 'label': 'Insolvency proceedings' },
      { 'status': 'registered', 'label': 'Registered' },
      { 'status': 'removed', 'label': 'Removed' },
      { 'status': 'closed', 'label': 'Closed' },
      { 'status': 'open', 'label': 'Open' },
      { 'status': 'unknown', 'label': 'Unknown' },
    ]
  }),
  computed: {
    ...mapGetters([
      'RegistrationReferrerList',
      'RegistrationEmailExists',
      'RegistrationBusinessExists',
      'RegistrationExperianList',
      'RegistrationWaitingForExperian',
      // 'RegistrationInProgress',
      'Referrals',
      'PlatformUser',
      'UserHasRole',
    ]),
    emailErrorMessage() {
      return this.RegistrationEmailExists ? ['Email address is already registered'] : []
    },
    businessErrorMessage() {
      return this.RegistrationBusinessExists ? ['Business is already registered'] : []
    },
    colsWidth() {
      return 12
    },
    dialog: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      },
    },
    businessDetailsComplete: function () {
      if (this.businessCheckTried) {
        return !_.isEmpty(this.updateData.name) && !_.isEmpty(this.updateData.address.post_code)
      }
      return true
    },
    verifiedEmail: {
      get() {
        return this.updateData.users[0].email
      },
      set: _.debounce(function (email) {
        this.updateData.users[0].email = email
        this.verifyRegistrationEmail(email)
      }, 500),
    },
    loqateOptions: function () {
      return [
        {value: null, text: 'Select an address', disabled: true},
        ...this.loqate.map(address => {
          return {value: address.Id, text: `${address.Text}, ${address.Description}`}
        }),
      ]
    },
    titleSelect: {
      get: function () {
        if (this.selectedTitle === undefined && this.updateData.users[0].name.title) {
            return this.titles.includes(this.updateData.users[0].name.title) ?
               this.updateData.users[0].name.title : 'Other'
        }

        return this.selectedTitle
      },
      set: function (value) {
        this.selectedTitle = value
      },
    },
    vFlexNameProps: function() {
      if (this.showTitleInput) {
        return {
          xs12: true,
          sm4: true,
          md4: true,
        }
      } else {
        return {
          xs12: true,
          sm5: true,
          md5: true,
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'verifyRegistrationEmail',
      'verifyRegistrationBusiness',
      'getExperianList',
      'clearRegistration',
      'addNotification',
      'updateRegistration',
      'getReferrals',
      'setReferralSearch',
      'getRegistrationReferrerList',
    ]),
    closeDialog() {
      this.resetUpdateData()
      this.clearRegistration()
      this.dialog = false
    },
    searchCompaniesHouse: function (q) {
      companiesHouse.searchCompanies(q, 10, 0).then(result => (this.businesses = result.items))
    },
    searchLoqate: function (q) {
      if (!this.searching) {
        this.showAddressSelect = false
        loqate.search(q).then(result => {
          if (result.Items.length === 1 && result.Items[0].Type === 'Postcode') {
            this.selectLoqateBusiness(result.Items[0])
          } else {
            this.loqate = result.Items
          }
        })
      }
    },

    selectBusiness: async function (business) {
      business.sic_codes = await companiesHouse.getSicCodes(business.company_number).catch(() => null);
      business.sic_codes = business.sic_codes ? JSON.stringify(business.sic_codes) : null;

      this.business = {
        BusinessRef: business.company_number,
        BusinessStatus: business.company_status,
        RegisteredCompanySicCodes: business.sic_codes,
        CommercialName: business.title,
        BusinessLocation: {
          LocationLine1: `${business.address.premises}, ${business.address.address_line_1}`,
          LocationLine2: business.address.address_line_2,
          LocationLine3: business.address.locality,
          LocationLine4: business.address.region,
          LocationLine5: null,
          City: business.address.locality,
          Postcode: business.address.postal_code,
        },
      }

      this.verifyRegistrationBusiness(this.business.BusinessRef)
      this.manualAddress = true
    },
    selectLoqateBusiness: function (business) {
      this.showAddressSelect = false
      this.searching = true
      if (typeof business === 'string') {
        business = {Id: business, Type: null}
      }
      if (business.Type === 'Postcode') {
        loqate.searchContainer(business.Text, business.Id).then(result => {
          this.loqate = result.Items
          this.showAddressSelect = true
        })
      } else {
        loqate.retrieve(business.Id).then(
          response =>
            (this.business = {
              BusinessRef: response.Items[0].Id,
              BusinessStatus: 'unknown',
              CommercialName: response.Items[0].Company,
              BusinessLocation: {
                LocationLine1: response.Items[0].Line1,
                LocationLine2: response.Items[0].District,
                LocationLine3: response.Items[0].City,
                LocationLine4: response.Items[0].Province,
                LocationLine5: null,
                City: response.Items[0].City,
                Postcode: response.Items[0].PostalCode,
              },
            }),
        )

        this.showManualAddress = true
        this.showSearchBox = false
      }
      this.searching = false
    },
    setBusinessDetails() {
      this.business.CommercialName = this.updateData.name
      this.business.BusinessRef = this.updateData.business_ref || ''
      this.business.BusinessStatus = this.updateData.business_status || 'unknown'
      this.business.RegisteredCompanySicCodes = this.updateData.registered_company_sic_codes || ''

      this.business.BusinessLocation = {
        LocationLine1: this.updateData.address.line_1,
        LocationLine2: this.updateData.address.line_2,
        LocationLine3: this.updateData.address.line_3,
        LocationLine4: this.updateData.address.line_4,
        LocationLine5: this.updateData.address.line_5,
        Postcode: this.updateData.address.post_code,
      }
    },
    prepareDetailsAndUpdate() {
      this.registrationInProgress = true
      this.registrationSuccess = null
      this.step = this.UserHasRole('Platform') ? 5 : 4;

      this.updateData.name = this.business.CommercialName
      this.updateData.address.line_1 = this.business.BusinessLocation.LocationLine1
      this.updateData.address.line_2 = this.business.BusinessLocation.LocationLine2
      this.updateData.address.line_3 = this.business.BusinessLocation.LocationLine3
      this.updateData.address.line_4 = this.business.BusinessLocation.LocationLine4
      this.updateData.address.line_5 = this.business.BusinessLocation.LocationLine5
      this.updateData.address.post_code = this.business.BusinessLocation.Postcode
      this.updateData.business_ref = this.business.BusinessRef
      this.updateData.business_status = this.business.BusinessStatus
      this.updateData.registered_company_sic_codes = this.business.RegisteredCompanySicCodes

      this.updateRegistration({
        updateData: this.updateData,
        referral: this.referral,
      })
        .then(() => {
          this.registrationInProgress = false
          this.registrationSuccess = true
          setTimeout(() => {
            this.closeDialog();
          }, 2000);
        })
        .catch(error => {
          this.registrationInProgress = false
          this.registrationSuccess = false;
          this.registrationError = error.message;
        })
    },
    startCase: function (str) {
      str = _.lowerCase(str)
      return _.startCase(str)
    },
    isDefined: function (value) {
      return _.isUndefined(value) === false
    },
    isFilled: function (value) {
      return !_.isEmpty(value)
    },
    resetUpdateData: function () {
      this.registrationSuccess = null
      this.updateData = {
        name: null,
        is_limited: false,
        auto_send_enquiries: false,
        address: {
          line_1: null,
          line_2: null,
          line_3: null,
          line_4: null,
          line_5: null,
          post_code: null,
        },
        referrer: {
          id: null,
        },
        users: [
          {
            name: {
              title: null,
              first: null,
              last: null,
            },
            email: null,
            phone: null,
            newsletter_signup: false,
          },
        ],
      }
    },
    validateSteps: function(upToStep) {
      for (let i = upToStep; i > 0; i--) {
        // Validating simultaneously not working, hence setTimeout
        setTimeout(this.$refs[`step${i}ref`].validate, i * 200);
      }
    },
  },
  mounted() {
    if (_.isEmpty(this.RegistrationReferrerList)) {
      this.getRegistrationReferrerList()
    }
  },
  watch: {
    show: function () {
      this.step = 1
      this.resetUpdateData()
      _.merge(this.updateData, this.customer)
      this.setBusinessDetails()
    },
    companiesHouseSearch: _.debounce(function (newQuery) {
      this.searchCompaniesHouse(newQuery)
    }, 250),
    companiesHouse: function (business) {
      this.selectBusiness(business)
    },
    loqateQuery: function (business) {
      this.selectLoqateBusiness(business)
    },
    loqateQuerySearch: _.debounce(function (newQuery = '', oldQuery = '') {
      if (newQuery.length < 3) {
        this.loqate = []
      } else if (newQuery.toLowerCase() !== oldQuery.toLowerCase() && newQuery !== this.lastLoqateQuery) {
        this.searchLoqate(newQuery)
        this.lastLoqateQuery = newQuery
      }
    }, 250),
    loqateQueryNameSearch: _.debounce(function (newQuery = '', oldQuery = '') {
      if (newQuery.length < 3) {
        this.loqate = []
      } else if (newQuery.toLowerCase() !== oldQuery.toLowerCase()) {
        this.searchLoqate(newQuery)
      }
    }, 250),
    selectedAddress: function (id) {
      this.selectLoqateBusiness(id)
    },
    titleSelect: function() {
      if (this.selectedTitle === undefined) {
        this.selectedTitle = this.titleSelect
      }

      if (this.selectedTitle === 'Other') {
        if (this.titles.includes(this.updateData.users[0].name.title)) {
          this.updateData.users[0].name.title = ''
        }
        this.showTitleInput = true
      } else {
        this.updateData.users[0].name.title = this.selectedTitle
        this.showTitleInput = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-stepper__step {
    .v-stepper__step__step .v-icon {
      font-size: 1rem;
    }
    &.v-stepper__step--error .v-stepper__step__step {
      background: var(--v-error-base);

      .v-icon {
        color: white;
      }
    }

    &.v-stepper__step--complete {
      .v-stepper__step__step.primary {
        background-color: var(--v-accent-base) !important;
      }

      &.v-stepper__step--error .v-stepper__label {
        color: var(--v-error-base);
      }
    }
  }

  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
